import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_APPOINTMENT_UPCOMING_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type {
  GetUpcomingAppointmentsPayload,
  GetUpcomingAppointmentsResult,
} from '../types/getUpcomingAppointment.types';

export const UPCOMING_APPOINTMENT_TAGS = 'getUpcomingAppointments';

export const getUpcomingAppointment = (builder: BuilderType) =>
  builder.query<GetUpcomingAppointmentsResult, GetUpcomingAppointmentsPayload>({
    keepUnusedDataFor: 0,
    providesTags: [UPCOMING_APPOINTMENT_TAGS],
    query: (data) => ({
      data,
      method: 'POST',
      url: GET_APPOINTMENT_UPCOMING_URL,
    }),
    transformResponse: (response: GenericApiResponse<GetUpcomingAppointmentsResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
